import React from 'react'
import { connect } from 'react-redux'
import {
  Route,
  Switch
} from 'react-router-dom'
// Local
import { PAGES } from '../../constant'
import Account from '../account'
import Encounter from '../encounter/encounter'
import Appointments from '../encounter'
import Footer from './Footer'
import Header from './header'
import Home from '../home'
import Patient from '../patient'
import PatientSnapshot from '../encounter/snapshot/patientSnapshot'
import Report from '../report'
import Version from '../version'

type RootState = {
  router: {
    location: {
      pathname: string
    }
  }
}

type AuthenticatedProps = {
  pathname: string
}

function Authenticated(props: AuthenticatedProps): JSX.Element {
  const { pathname } = props

  return (
    <div id="authenticated">
      <Header active={ pathname } />
      <Switch>
        <Route path={ `${PAGES.HOME}:date?` } component={ Home } />
        <Route path={ `${PAGES.ENCOUNTER_DETAIL}:id` } component={ Encounter } />
        <Route path={ PAGES.ENCOUNTER_LIST } component={ Appointments } />
        <Route path={ `${PAGES.PATIENT_SNAPSHOT}:id` } component={ PatientSnapshot } />
        <Route path={ PAGES.PATIENT_LIST } component={ Patient } />
        <Route path={ PAGES.REPORT } component={ Report } />
        <Route path={ PAGES.ACCOUNT } component={ Account } />
        <Route path={ PAGES.VERSION } component={ Version } />
      </Switch>
      <Footer />
    </div>
  )
}

export default connect(
  (state: RootState) => ({
    pathname: state.router.location.pathname
  }),
  {}
)(Authenticated)
